import { render, staticRenderFns } from "./Lemma.vue?vue&type=template&id=ba80e2c2&"
import script from "./Lemma.vue?vue&type=script&lang=js&"
export * from "./Lemma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports